import { Component } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { gamesTagsStore } from "../stores/gamesTagsModal";
import { Box, Container, Button, Header, Pagination, SpaceBetween, Table, TextFilter, FormField, Input, Tabs, Select, Toggle } from "@cloudscape-design/components";
import GamesMetaTagGameList from "./GamesMetaTagGameList";
import { userStore } from "../stores/access";

class FormTag extends Component {
	constructor(props) {
		super(props);

		this.translateTypes = [
			{ label: "Local", value: "local" },
			{ label: "International", value: "international" },
		];

		this.state = {
			form: { name: props.defaultName || "", translate: props.defaultTranslate || "", translateType: props.defaultTranslateType, active: props.defaultActive || false },
			errors: {},
		};
	}

	updateField(fields) {
		this.setState((prev) => ({
			form: {
				...prev.form,
				...fields,
			},
		}));
		this.clearFieldError(Object.keys(fields));
	}

	clearFieldError(fieldNames) {
		fieldNames.forEach((fieldName) => {
			if (this.state.errors[fieldName]) {
				this.setState((prev) => {
					const newErrors = { ...prev.errors };
					delete newErrors[fieldName];
					return { errors: newErrors };
				});
			}
		});
	}

	validateTag() {
		const { form } = this.state;
		const errors = {};
		if (!form.name.trim()) errors.name = "Name is required";
		if (!form.translate.trim()) errors.translate = "translate is required";
		if (!form.translateType) errors.translateType = "translate type is required";
		this.setState({ errors });
		return Object.keys(errors).length === 0;
	}

	handleClear() {
		this.setState({ form: { name: "", translate: "" }, errors: {} });
		if (this.props.onClear) this.props.onClear();
	}

	handleSubmit() {
		if (!this.validateTag()) return;
		if (this.props.onSubmit) {
			this.props.onSubmit(
				{
					name: this.state.form.name?.trim(),
					translate: this.state.form.translate,
					translateType: this.state.form.translateType,
					active: this.state.form.active,
				},
				this.handleClear.bind(this),
			);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.defaultName !== this.props.defaultName || prevProps.defaultTranslate !== this.props.defaultTranslate || prevProps.defaultTranslateType !== this.props.defaultTranslateType || prevProps.defaultActive !== this.props.defaultActive) {
			this.setState({ form: { name: this.props.defaultName || "", translate: this.props.defaultTranslate || "", translateType: this.props.defaultTranslateType, active: this.props.defaultActive || false }, errors: {} });
		}
	}

	render() {
		return (
			<>
				<SpaceBetween direction="vertical" size="s">
					<FormField stretch>
						<SpaceBetween direction="horizontal" size="s">
							<b>Active:</b>
							<Toggle label="Active" onChange={({ detail }) => this.updateField({ active: detail.checked })} checked={this.state.form.active}></Toggle>
						</SpaceBetween>
					</FormField>
					<FormField label="Name" errorText={this.state.errors.name} stretch>
						<Input placeholder="Name" value={this.state.form.name} onChange={({ detail }) => this.updateField({ name: detail.value.replace(".", "") })} />
					</FormField>
					<FormField label="Translate Type" errorText={this.state.errors.translateType} stretch>
						<Select placeholder="Select translate type" onChange={({ detail }) => this.updateField({ translateType: detail.selectedOption.value })} selectedOption={this.translateTypes.find((option) => option.value === this.state.form.translateType)} value={this.state.form.translateType} options={this.translateTypes} />
					</FormField>
					<FormField label="Translate" errorText={this.state.errors.translate} stretch>
						<Input placeholder="Translate" value={this.state.form.translate} onChange={({ detail }) => this.updateField({ translate: detail.value })} />
					</FormField>
				</SpaceBetween>
				<Box variant="div" size="s" margin={{ top: "l" }}>
					<SpaceBetween direction="horizontal" size="s">
						<Button disabled={this.state.form.name.trim() === this.props.defaultName.trim() && this.state.form.translate.trim() === this.props.defaultTranslate.trim() && this.state.form.translateType === this.props.defaultTranslateType && !!this.state.form.active === !!this.props.defaultActive} loading={this.props.loading} onClick={() => this.handleSubmit()} variant="primary">
							{this.props.submitLabel || "Save"}
						</Button>
						{this.props.isClear && (
							<Button onClick={() => this.handleClear()} variant="link">
								{this.props.clearLabel || "Clear"}
							</Button>
						)}
					</SpaceBetween>
				</Box>
			</>
		);
	}
}

class GamesMetaTagDetail extends Component {
	constructor(props) {
		super(props);
		this.debounceSearchTimeout = null;
		this.state = {
			updateLoading: false,
			createTagLoading: false,
			updateTagLoading: false,
			editTag: false,
			errors: {},
		};
	}

	setFilter(options) {
		this.props.setGameTag((prev) => ({
			...prev,
			filters: {
				...prev.filters,
				...options,
			},
		}));
	}

	loadGameTags() {
		this.props.Interface.loadGameTags(this.props.metaTagDetails.id);
	}

	handleClearFilter() {
		this.setFilter({
			sorting: {
				column: "id",
				direction: "asc",
			},
			search: "",
			page: 1,
		});
		setTimeout(() => {
			this.loadGameTags();
		}, 50);
	}

	handleCreateTag(tag, clearCallback) {
		this.setState({ createTagLoading: true });

		this.props.Interface.createGameTag({ ...tag, metaTagId: this.props.metaTagDetails.id })
			.then(() => {
				clearCallback();
			})
			.finally(() => {
				this.setState({ createTagLoading: false });
			});
	}

	handleUpdateMetaTag(metaTag) {
		this.setState({ updateLoading: true });

		this.props.Interface.updateGameMetaTag({ id: this.props.metaTagDetails.id, ...metaTag })
			.then(() => {
				this.props.setMetaTagDetails({ id: this.props.metaTagDetails.id, ...metaTag });
			})
			.finally(() => {
				this.setState({ updateLoading: false });
			});
	}

	handleClearMetaTag() {
		this.props.setMetaTagDetails(null);
	}

	handleEditTag(tag, clearCallback) {
		this.setState({ updateTagLoading: true });
		this.props.Interface.updateGameTag({ metaTagId: this.props.metaTagDetails.id, id: this.state.editTag.id, ...tag })
			.then(() => {
				clearCallback();
			})
			.finally(() => {
				this.setState({ updateTagLoading: false });
			});
	}

	componentDidMount() {
		this.loadGameTags();
	}

	render() {
		return (
			<Tabs
				tabs={[
					{
						label: "Details",
						id: "details",
						content: (
							<Container
								header={
									<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
										<Header variant="h3">{`Meta Tag ${this.props.metaTagDetails.name}`}</Header>
										<Button variant="primary" onClick={() => this.handleClearMetaTag()} iconName="arrow-left" wrapText={false}>
											Back
										</Button>
									</div>
								}>
								<FormTag
									defaultTranslate={this.props.metaTagDetails.translate}
									defaultTranslateType={this.props.metaTagDetails.translateType}
									defaultName={this.props.metaTagDetails.name}
									defaultActive={this.props.metaTagDetails.active}
									loading={this.state.updateLoading}
									onSubmit={(metaTag) => {
										this.handleUpdateMetaTag(metaTag);
									}}
								/>
							</Container>
						),
					},
					{
						label: "Tags",
						id: "list",
						content: (
							<SpaceBetween size="m">
								<Table
									selectedItems={this.state.editTag ? [this.state.editTag] : []}
									selectionType="single"
									onSelectionChange={({ detail }) => {
										this.setState({ editTag: detail.selectedItems[0] });
									}}
									columnDefinitions={[
										{
											id: "id",
											header: "ID",
											sortingField: "id",
											cell: (item) => item.id,
										},
										{
											id: "name",
											header: "Name",
											sortingField: "name",
											cell: (item) => <span style={{ maxWidth: "100px", display: "block", whiteSpace: "normal" }}>{item.name}</span>,
										},
										{
											id: "translate",
											header: "Translate",
											sortingField: "translate",
											cell: (item) => <span style={{ maxWidth: "100px", display: "block", whiteSpace: "normal" }}>{item.translate}</span>,
										},
										{
											id: "active",
											header: "Active",
											sortingField: "active",
											cell: (item) => <>{item.active ? "Yes" : "No"}</>,
										},
										{
											id: "createdAt",
											header: "Created At",
											sortingField: "createdAt",
											cell: (item) => <>{new Date(item.createdAt).toLocaleDateString() + " " + new Date(item.createdAt).toLocaleTimeString()}</>,
										},
										{
											id: "action",
											header: "Action",
											minWidth: 140,
											maxWidth: 140,
											cell: (item) => {
												const isActive = this.state.editTag && this.state.editTag.id === item.id;
												return (
													<Button variant="link" onClick={() => this.setState({ editTag: isActive ? false : item })}>
														{isActive ? "Cancel" : "Edit"}
													</Button>
												);
											},
										},
									]}
									enableKeyboardNavigation
									items={this.props.gameTag.data}
									loading={!this.props.gameTag.loaded}
									sortingColumn={{ sortingField: this.props.gameTag.filters.sorting.column }}
									sortingDescending={this.props.gameTag.filters.sorting.order === "desc"}
									onSortingChange={({ detail }) => {
										this.setFilter({
											sorting: { column: detail.sortingColumn.sortingField, order: detail.isDescending ? "desc" : "asc" },
										});
										setTimeout(() => {
											this.loadGameTags();
										}, 50);
									}}
									trackBy="name"
									empty={
										<Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
											<SpaceBetween>
												<b>No tags</b>
												<Button variant="link" onClick={() => this.handleClearFilter()}>
													Clear filters
												</Button>
											</SpaceBetween>
										</Box>
									}
									filter={
										<TextFilter
											filteringPlaceholder="Find tag"
											filteringText={this.props.gameTag.filters.search}
											onChange={({ detail }) => {
												this.setFilter({
													search: detail.filteringText,
												});
												if (this.debounceSearchTimeout) clearTimeout(this.debounceSearchTimeout);
												this.debounceSearchTimeout = setTimeout(() => {
													this.setFilter({
														page: 1,
													});
													setTimeout(() => {
														this.loadGameTags();
													}, 50);
												}, 400);
											}}
										/>
									}
									header={
										<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", width: "100%" }}>
											<Header variant="h3">Table Tags</Header>
											<Button variant="primary" wrapText={false} onClick={() => this.handleClearMetaTag()} iconName="arrow-left">
												Back
											</Button>
										</div>
									}
									pagination={
										<Pagination
											currentPageIndex={this.props.gameTag.filters.page}
											onChange={({ detail }) => {
												this.setFilter({
													page: detail.currentPageIndex,
												});
												setTimeout(() => {
													this.loadGameTags();
												}, 50);
											}}
											pagesCount={this.props.gameTag.totalPages}
											disabled={this.props.gameTag.totalPages === 1}
										/>
									}
								/>
								<Container header={<Header variant="h3">{this.state.editTag ? `Edit Tag ${this.state.editTag.name}` : "Create New Tag"}</Header>}>
									{this.state.editTag ? (
										<FormTag
											defaultTranslate={this.state.editTag.translate}
											defaultName={this.state.editTag.name}
											defaultActive={this.state.editTag.active}
											defaultTranslateType={this.state.editTag.translateType}
											loading={this.state.updateTagLoading}
											isClear={true}
											submitLabel="Edit"
											clearLabel="Cancel"
											onClear={() => this.setState({ editTag: false })}
											onSubmit={(tag, clearCallback) => {
												this.handleEditTag(tag, clearCallback);
											}}
										/>
									) : (
										<FormTag
											defaultTranslate={""}
											defaultTranslateType={""}
											defaultName={""}
											defaultActive={false}
											submitLabel="Create"
											isClearSubmit={true}
											loading={this.state.createTagLoading}
											onSubmit={(tag, clearCallback) => {
												this.handleCreateTag(tag, clearCallback);
											}}
										/>
									)}
								</Container>
							</SpaceBetween>
						),
					},
					{
						label: "Games",
						id: "games",
						content: <GamesMetaTagGameList t={this.props.t} tags={this.props.gameTag.data} onClearMetaTag={() => this.props.setMetaTagDetails()} metaTagId={this.props.metaTagDetails.id} />,
					},
				]}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const user = useRecoilValue(userStore);
		const gameTag = useRecoilValue(gamesTagsStore);
		const setGameTag = useSetRecoilState(gamesTagsStore);

		return <Component {...props} user={user} gameTag={gameTag} setGameTag={setGameTag} />;
	};
}

export default withRecoil(GamesMetaTagDetail);
